// extracted by mini-css-extract-plugin
module.exports = {"iconWrapper":"styles-module--iconWrapper--49vA-","img":"styles-module--img--1KHC8"};